module.exports = __webpack_public_path__ + "img/Prime2_logo_channel_m.765bed66.svg";